import { css } from 'lit';
export const carouselStyles = css `
    :host {
        position: relative;
        display: grid;
        min-width: 0;
        margin-left: auto;
        margin-right: auto;
        z-index: 1;
    }

    .hlx-carousel {
        display: flex;
        flex-direction: column;
        gap: var(--hlx-spacing-2xl);
        width: 100%;
        height: 100%;
    }

    .hlx-carousel-inverted {
        background-color: var(--hlx-background-color-inverted);
    }

    .hlx-carousel-slides {
        display: flex;
        align-items: center;
        justify-items: center;
    }
    .hlx-carousel:not(.hlx-carousel-dragging) .hlx-carousel-slides {
        cursor: grab;
    }

    .hlx-carousel-slides::-webkit-scrollbar {
        display: none;
    }

    .hlx-carousel-scroll-bar:focus-visible {
        outline: 2px solid var(--hlx-color-brand-default);
        outline-offset: 2px;
    }

    .hlx-carousel-actions {
        display: flex;
        align-items: center;
        gap: var(--hlx-spacing-lg);
    }

    .hlx-carousel-scroll-bar {
        flex-grow: 1;
        height: 24px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .hlx-carousel:not(.hlx-carousel-dragging) .hlx-carousel-scroll-bar {
        cursor: grab;
    }

    .hlx-carousel-scroll-bar-track {
        background: var(--hlx-color-dark-weak-2);
    }
    .hlx-carousel-inverted .hlx-carousel-scroll-bar-track {
        background: var(--hlx-color-neutral-50);
    }

    .hlx-carousel-scroll-bar-indicator {
        background: var(--hlx-color-dark-default);
        height: 4px;
        transition: height var(--hlx-motion-duration-default) var(--hlx-motion-easing-in-out);
    }
    .hlx-carousel-inverted .hlx-carousel-scroll-bar-indicator {
        background: var(--hlx-color-neutral-0);
    }
    .hlx-carousel-scroll-bar:hover .hlx-carousel-scroll-bar-indicator {
        height: 6px;
    }

    .hlx-carousel-button-group {
        display: flex;
        gap: var(--hlx-spacing-md);
    }

    .hlx-carousel.hlx-carousel-dragging {
        cursor: grabbing;
    }

    .swiper {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
    }
    .swiper-wrapper {
        display: flex;
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        transition-property: transform;
        transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);
        box-sizing: content-box;
    }
    .swiper-android .swiper-slide,
    .swiper-ios .swiper-slide,
    .swiper-wrapper {
        transform: translate3d(0px, 0, 0);
    }
    .swiper-horizontal {
        touch-action: pan-y;
    }
    .swiper-slide {
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
        transition-property: transform;
        display: block;
    }
    .swiper-slide-invisible-blank {
        visibility: hidden;
    }

    /* Auto Height */
    .swiper-backface-hidden .swiper-slide {
        transform: translateZ(0);
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }

    /* Scrollbar */
    .swiper-scrollbar {
        position: relative;
        touch-action: none;
    }
    .swiper-scrollbar-disabled > .swiper-scrollbar,
    .swiper-scrollbar.swiper-scrollbar-disabled {
        display: none !important;
    }
    .swiper-horizontal > .swiper-scrollbar,
    .swiper-scrollbar.swiper-scrollbar-horizontal {
        width: calc(100% - 2 * var(--swiper-scrollbar-sides-offset, 1%));
        z-index: 50;
    }
    .swiper-scrollbar-cursor-drag {
        cursor: move;
    }
    .swiper-scrollbar-lock {
        display: none;
    }

    /* Navigation */
    .swiper-button-lock {
        display: none;
    }

    /* a11y */
    .swiper .swiper-notification {
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        opacity: 0;
        z-index: -1000;
    }
`;
//# sourceMappingURL=carousel.styles.js.map